import { createContext } from "react";


export const signatureContext = createContext()
